module.exports = __webpack_public_path__ + "static/media/wizualizacja-62.03656bb5.png";